import React, { useState } from "react";
import { ethers } from "ethers";

const FeeManager = ({ provider, account }) => {
    const [kaiaFees, setKaiaFees] = useState("0");
    const [goldFees, setGoldFees] = useState("0");
    const [silverFees, setSilverFees] = useState("0");

    const dexAddress = process.env.REACT_APP_DEX_ADDRESS;
    const goldAddress = process.env.REACT_APP_GOLD_ADDRESS;
    const silverAddress = process.env.REACT_APP_SILVER_ADDRESS;

    const DEX_ABI = [
        "function accumulatedKaiaFees() view returns (uint256)",
        "function accumulatedGoldFees() view returns (uint256)",
        "function accumulatedSilverFees() view returns (uint256)",
        "function withdrawFees()"
    ];

    const fetchFees = async () => {
        if (!provider || !account) return;
        const dex = new ethers.Contract(dexAddress, DEX_ABI, provider);
        const kaia = await dex.accumulatedKaiaFees();
        const gold = await dex.accumulatedGoldFees();
        const silver = await dex.accumulatedSilverFees();

        setKaiaFees(ethers.formatEther(kaia));
        setGoldFees(ethers.formatEther(gold));
        setSilverFees(ethers.formatEther(silver));
    };

    const withdrawFees = async () => {
        if (!provider || !account) return;
        const signer = await provider.getSigner();
        const dex = new ethers.Contract(dexAddress, DEX_ABI, signer);

        try {
            const tx = await dex.withdrawFees();
            await tx.wait();
            alert("수수료 회수 완료");
            fetchFees();
        } catch (err) {
            console.error(err);
            alert("트랜잭션 실패");
        }
    };

    return (
        <div>
            <h3>수수료 관리</h3>
            <button onClick={fetchFees}>수수료 조회</button>
            <div>Kaia 수수료: {kaiaFees} KAI</div>
            <div>Gold 수수료: {goldFees} GOLD</div>
            <div>Silver 수수료: {silverFees} SILVER</div>
            <button onClick={withdrawFees}>수수료 회수</button>
        </div>
    );
};

export default FeeManager;
